import type { PricingFaqSummary } from "@/lib/catalog-faq";

export function hasTrustedPriceDrop(summary: PricingFaqSummary): boolean {
  if (summary.dealMovement !== "down") return false;
  const referencePrice = Number(summary.dealReferencePrice);
  const deltaPercent = Number(summary.dealDeltaPercent);
  const confidence = Number(summary.dealConfidence);
  if (!Number.isFinite(referencePrice) || referencePrice <= 0) return false;
  if (!Number.isFinite(deltaPercent) || deltaPercent >= 0) return false;
  return confidence >= 0.5;
}
